import { useEffect, useRef } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Spinner } from '../../components/UI';

export function CallbackPage() {
  const { processCallback } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');

    if (error) {
      console.error('OAuth error:', error, params.get('error_description'));
      window.location.href = '/';
      return;
    }

    if (code && state) {
      processCallback(code, state).then(() => {
        window.location.href = '/';
      });
    } else {
      window.location.href = '/';
    }
  }, [processCallback]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <Spinner size="lg" className="mx-auto mb-4" />
        <p className="text-gray-600">Iniciando sesión...</p>
      </div>
    </div>
  );
}
